import { PaintedScene } from '../PaintedScene';

export const SAND_FLAT_PHASER_KEY = 'SandFlatScene' as const;
export const SAND_FLAT_MANIFEST_KEY = 's-212-sand-flat' as const;

export class SandFlatScene extends PaintedScene {
  constructor() {
    super(SAND_FLAT_PHASER_KEY, SAND_FLAT_MANIFEST_KEY);
  }
}
